// Copyright 2025 - Hewlett Packard Enterprise Company
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Box, ResponsiveContext } from 'grommet';
import ChatHeader from './ChatHeader';
import ChatFooter from './ChatFooter';
import ChatMainContent from './ChatMainContent';

export default function ChatContainer({ onClose }) {
  const size = useContext(ResponsiveContext);

  return (
    <Box data-testid="chatContainerBox" height="100vh">
      <Box
        fill="vertical"
        gap="none"
        width={{
          min: !['xsmall', 'small'].includes(size) ? 'medium' : undefined,
        }}
      >
        <ChatHeader onClose={onClose} />
        <ChatMainContent />
      </Box>
      <ChatFooter />
    </Box>
  );
}

ChatContainer.propTypes = {
  onClose: PropTypes.func.isRequired,
};
